<template lang='pug'>
  div(id='root')
    router-view()

    //- button(class="c-btn-top", :class="isShowButtonTop ? 'is-show' : ''" @click="goTop()")
    a(class="c-btn-top", :class="isShowButtonTop ? 'is-show' : ''" href="#" v-scroll-to="'#root'")
      i(class="u-icon") arrow_right
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    data () {
      return {
        isShowButtonTop: false
      }
    },

    methods: {
      ...mapActions({
        loadCompany: 'loadCompany'
      }),

      handleScroll () {
        let win = window.$(window)

        if (win.scrollTop() >= win.height()) {
          this.isShowButtonTop = true
        } else {
          this.isShowButtonTop = false
        }
      },

      goTop () {
        window.$(window).animate({scrollTop: 0}, '2000', 'swing')
      }
    },

    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },

    created () {
      this.loadCompany()
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/Root.vue